import { AdSlotConstraintTypeEnum } from '../../../dto/recs.dto';
import { AdSlotConstraint } from '../../../entities/ad-slot-constraint';
import {
  AdSlotConstraintValidatorInterface,
} from '../../../interfaces/components/validator/ad-slot-constraint-validator.interface';
import { UserContext } from '../../context/user.context';
import { Injectable } from '../../dependency-injection/decorators';

@Injectable()
export class AdSlotConstraintNpiValidator implements AdSlotConstraintValidatorInterface {
  public constructor (private readonly userContext: UserContext) {
  }

  public supports (adSlotConstraint: AdSlotConstraint): boolean {
    return adSlotConstraint.getType() === AdSlotConstraintTypeEnum.NPI;
  }

  public validate (adSlotConstraint: AdSlotConstraint): Promise<boolean> | boolean {
    if (!this.userContext.hasNpi()) {
      return false;
    }

    if (adSlotConstraint.getConstraint()?.any) {
      return true;
    }

    const npis = this.userContext.getNpis();
    return npis
      .filter((npi) => npi.getEncryptedNumber() !== null)
      .map((npi) => npi.getEncryptedNumber() as string)
      .some((encryptedNumber) => (adSlotConstraint.getConstraint()?.values ?? []).includes(encryptedNumber));
  }
}
